"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  z50: "#FFF7FA",
  z100: "#FFEDF3",
  z200: "#FFD8E5",
  z300: "#FFADC9",
  z400: "#FF6E9E",
  z500: "#EB447C",
  z600: "#D92662",
  z700: "#C2134E",
  z800: "#770229",
  z900: "#4E041D"
};